import { Button, Callout, Dialog, DialogBody, DialogFooter, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import Client from '../../../client'

interface Props {
  channelName: any
  listingId: any
  isOpen: any
  onClose: any
}
interface State {
  loading: boolean
  confirmedDeletion: boolean
  error?: any
}
export default class DeleteDialog extends React.Component<Props, State> {
  private confirmTimeout?: ReturnType<typeof setTimeout>

  state: State = {
    loading: false,
    confirmedDeletion: false
  }

  resetConfirm = () => {
    clearTimeout(this.confirmTimeout)
    this.setState({
      confirmedDeletion: false,
      error: null
    })
  }

  deleteListing = async () => {
    if (!this.state.confirmedDeletion) {
      this.setState({
        confirmedDeletion: true
      })

      this.confirmTimeout = setTimeout(() => {
        this.setState({ confirmedDeletion: false })
      }, 2500)

      return
    }

    const { channelName, listingId } = this.props
    this.setState({ loading: true })
    try {
      await Client.removeListing(channelName, listingId)
      this.setState({ loading: false }, this.props.onClose(true))
    } catch (error) {
      this.setState({ loading: false, error: error.response })
    }
  }

  render() {
    const { isOpen, onClose } = this.props
    const { loading, confirmedDeletion, error } = this.state

    return (
      <Dialog
        isOpen={isOpen}
        onClose={() => {
          this.resetConfirm()
          onClose(false)
        }}
        title="Delete listing"
        icon={IconNames.TRASH}
      >
        <DialogBody>
          {error && (
            <Callout intent={Intent.DANGER} title="Error">
              Failed to delete listing. Please refresh and try again.
            </Callout>
          )}
          <h3>Are you sure you want to delete this listing?</h3>
          <ul>
            <li>This will delete this listing from Lister</li>
            <li>
              This will <strong>not</strong> delete this listing off of the marketplace
            </li>
            <li>
              <strong>This is irreversible</strong>
            </li>
          </ul>
        </DialogBody>
        <DialogFooter
          actions={
            <Button
              loading={loading}
              intent={confirmedDeletion ? Intent.DANGER : Intent.PRIMARY}
              onClick={this.deleteListing}
            >
              {confirmedDeletion ? 'Click to confirm deletion' : 'Permanently delete listing'}
            </Button>
          }
        />
      </Dialog>
    )
  }
}
